import { Controller } from "@hotwired/stimulus"

// Menu usa `position: fixed` (calculado via getBoundingClientRect) em vez de `absolute`,
// para escapar do corte de containers com overflow (ex.: ds-table com scroll horizontal)
// que, do contrário, cortariam o menu na última linha. Fixed escapa de overflow:hidden/auto
// de ancestrais normais (só fica preso se algum ancestral tiver transform/filter/perspective,
// o que não é o caso aqui) — por isso o menu não precisa (e não deve) sair da árvore do
// controller: mover para document.body quebraria o rastreamento de target do Stimulus.
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this._handleOutsideClick = this._handleOutsideClick.bind(this)
    this._reposition = this._reposition.bind(this)
  }

  toggle() {
    if (this.menuTarget.hidden) {
      this._open()
    } else {
      this.close()
    }
  }

  close() {
    if (this.menuTarget.hidden) return
    this.menuTarget.hidden = true
    document.removeEventListener("click", this._handleOutsideClick)
    window.removeEventListener("scroll", this._reposition, true)
    window.removeEventListener("resize", this._reposition)
  }

  disconnect() {
    document.removeEventListener("click", this._handleOutsideClick)
    window.removeEventListener("scroll", this._reposition, true)
    window.removeEventListener("resize", this._reposition)
  }

  _open() {
    this.menuTarget.style.position = "fixed"
    this.menuTarget.style.margin = "0"
    this.menuTarget.hidden = false
    this._reposition()
    document.addEventListener("click", this._handleOutsideClick)
    window.addEventListener("scroll", this._reposition, true)
    window.addEventListener("resize", this._reposition)
  }

  _reposition() {
    if (this.menuTarget.hidden) return
    const anchor = this.element.getBoundingClientRect()
    const menuHeight = this.menuTarget.offsetHeight
    const spaceBelow = window.innerHeight - anchor.bottom
    const openUpward = spaceBelow < menuHeight + 8 && anchor.top > menuHeight + 8

    this.menuTarget.style.left = "auto"
    this.menuTarget.style.right = `${window.innerWidth - anchor.right}px`
    if (openUpward) {
      this.menuTarget.style.top = "auto"
      this.menuTarget.style.bottom = `${window.innerHeight - anchor.top + 4}px`
    } else {
      this.menuTarget.style.bottom = "auto"
      this.menuTarget.style.top = `${anchor.bottom + 4}px`
    }
  }

  _handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }
}
